import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateEasmAssetDetailsPanel = document.createElement('template');

templateEasmAssetDetailsPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

    <div id="easmFindingPanel">
       <gz-title id="panelTitle" fontWeight='500' fontSize='16'></gz-title>
       <div id="sections"></div>
       <div id="general-actions"></div>
    </div>
`;
